import API from "@vahak/core/dist/_services/const";
import useVahakHttpClient from "@vahak/core/dist/hooks/useVahakHttpClient";
import { useVahakMutationQuery } from "@vahak/core/dist/hooks/useVahakQueryClient";
import { QueryNames } from "@vahak/core/dist/_services/hooks/queryNames";

import { getAuthHeader } from "@vahak/core/dist/_services/utils/getAuthHeader";

export interface TransporterSearchPayloadType {
    page_number: number;
    city_id?: number[];
    states?: any;
    name?: string;
    service_type?: string[];
}

export interface TransporterSearchResponse {
    data: TransporterSearchResponseData;
}

export interface TransporterSearchResponseData {
    total_pages: number;
    total_records: number;
    page_number: number;
    data: any[];
}

interface SearchParams {
    cityId?: number;
    routeStateIds?: number[];
    service_type?: string[];
    name?: string;
    page?: number;
    transporterId?: number;
    sourcePlaceId?: string;
}

export async function transporterSearch({
    cityId,
    routeStateIds,
    service_type,
    name,
    page = 1,
    transporterId,
    sourcePlaceId
}: SearchParams) {
    try {
        const response = await fetch(`${API.TRANSPORTER_SEARCH}`, {
            method: "POST",
            headers: {
                ...getAuthHeader(),
                origin: "http://localhost:3000",
                referer: "http://localhost:3000/"
                // "user-agent": API.VERCEL_USER_AGENT
            },
            body: JSON.stringify({
                page_number: page,
                source_place_id: sourcePlaceId ? [sourcePlaceId] : undefined,
                states: routeStateIds,
                company_name: name,
                service_type,
                ...(transporterId && { company_id: [transporterId] })
            })
        });
        const dataFromServer = await response.json();

        return dataFromServer.data;
    } catch (e) {
        console.log(e);
        return undefined;
    }
}

interface ProfileReviewParams {
    id: string;
    limit?: number;
}

export async function getTransporterProfileReviews({ id, limit }: ProfileReviewParams) {
    try {
        const response = await fetch(`${API.TRANSPORTER_REVIEWS}?company_id=${id}${limit ? "&l=" + limit : ""}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                ...getAuthHeader(),
                origin: "http://localhost:3000",
                referer: "http://localhost:3000/"
                // "user-agent": API.VERCEL_USER_AGENT
            }
        });

        const dataFromServer = await response.json();

        return dataFromServer.data;
    } catch (e) {
        return undefined;
    }
}

export async function getTransporterProfileFaqs(id: number) {
    try {
        const response = await fetch(`${API.TRANSPORTER_FAQ}`, {
            method: "POST",
            headers: {
                ...getAuthHeader(),
                origin: "http://localhost:3000",
                referer: "http://localhost:3000/"
                // "user-agent": API.VERCEL_USER_AGENT
            },
            body: JSON.stringify({
                company_id: [id]
            })
        });

        const dataFromServer = await response.json();

        return dataFromServer.data;
    } catch (e) {
        console.log(e);
        return undefined;
    }
}

export function useTransporterSearch() {
    const { POST } = useVahakHttpClient();

    const search = ({ cityId, routeStateIds, service_type, name, page = 1, sourcePlaceId }: SearchParams) => {
        const payload = {
            page_number: page,
            city_id: cityId ? [cityId] : undefined,
            source_place_id: sourcePlaceId ? [sourcePlaceId] : undefined,
            state_id: routeStateIds,
            company_name: name,
            service_type
        };
        return POST<TransporterSearchPayloadType, TransporterSearchResponse>(`${API.TRANSPORTER_SEARCH}`, payload).then(
            (data) => data.data
        );
    };

    return useVahakMutationQuery<TransporterSearchResponseData, unknown, SearchParams>(
        QueryNames.transporters.getTransporterList,
        search
    );
}
